import { render, staticRenderFns } from "./eg_icon.vue?vue&type=template&id=5289c971&"
import script from "./eg_icon.vue?vue&type=script&lang=js&"
export * from "./eg_icon.vue?vue&type=script&lang=js&"
import style0 from "./eg_icon.vue?vue&type=style&index=0&id=5289c971&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports